import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"]

  change(event) {
    const file = event.target.files[0]
    if (!file) return

    const url = URL.createObjectURL(file)
    const preview = this.previewTarget

    if (preview.tagName === "IMG") {
      preview.src = url
    } else {
      const img = document.createElement("img")
      img.src = url
      img.className = preview.className
      preview.replaceWith(img)
    }
  }
}
